 import React from "react";
import * as constants from '../constants';
import * as commonConstants from '../../constants';
import CPSettingFont from "../../../../UI/Settings/CPSettingFont";
import CPSettingColor from "../../../../UI/Settings/CPSettingColor";
import CPSettingRange from "../../../../UI/Settings/CPSettingRange";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingText from "../../../../UI/Settings/CPSettingText";

const CommonStyles = ({settings, onChange}) => {
    return (
        <>
            <CPSettingFont
                font={settings?.[commonConstants.FONT]}
                onChange={onChange}
            />
            <CPSettingColor
                name={commonConstants.BACKGROUND_COLOR}
                label="Цвет основного фона"
                eventColor={settings?.[commonConstants.BACKGROUND_COLOR]}
                defaultColor={"#FFFFFF"}
                onChange={onChange}
            />
            <CPSettingRange
                name={commonConstants.BACKGROUND_OPACITY}
                value={settings?.[commonConstants.BACKGROUND_OPACITY]}
                defaultValue={settings?.[commonConstants.BACKGROUND_OPACITY] ?? 0}
                label="Прозрачность основного фона"
                step={5}
                onChange={onChange}
            />
            {/* <CPSettingSize
                name={commonConstants.BACKGROUND_BLUR}
                label="Размытие основного фона"
                eventValue={settings?.[commonConstants.BACKGROUND_BLUR]}
                defaultValue={'0px'}
                onChange={onChange}
            /> */}
            <CPSettingColor
                name={commonConstants.ACCENT_COLOR}
                label="Акцентный цвет"
                eventColor={settings?.[commonConstants.ACCENT_COLOR]}
                defaultColor={commonConstants.DEFAULT_COLOR_ACCENT}
                onChange={onChange}
            />
            <CPSettingColor
                name={commonConstants.TEXT_COLOR}
                label="Цвет подложки и фон карточек"
                eventColor={settings?.[commonConstants.TEXT_COLOR]}
                defaultColor="#EEEEEE"
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.ADDITIONAL_COLOR}
                label="Цвет элементов"
                eventColor={settings?.[constants.ADDITIONAL_COLOR]}
                defaultColor="#16161B"
                hint="Кнопки, названия залов, время в сетке, линии в сетке, цвет вкладок у зала"
                onChange={onChange}
            />
            <CPSettingRange
                name={constants.BACKGROUND_ADDITIONAL_OPACITY}
                value={settings?.[constants.BACKGROUND_ADDITIONAL_OPACITY]}
                defaultValue={settings?.[constants.BACKGROUND_ADDITIONAL_OPACITY] ?? 0}
                label="Прозрачность фона у подложки"
                step={5}
                onChange={onChange}
            />
            {/* <CPSettingSize
                name={constants.BACKGROUND_ADDITIONAL_BLUR}
                label="Размытие фона у подложки"
                eventValue={settings?.[constants.BACKGROUND_ADDITIONAL_BLUR]}
                defaultValue={'10px'}
                onChange={onChange}
            /> */}
            <CPSettingColor
                name={constants.SHEDULE_CARD_TEXT_COLOR}
                label="Цвет текста карточки"
                eventColor={settings?.[constants.SHEDULE_CARD_TEXT_COLOR]}
                defaultColor="#16161B"
                onChange={onChange}
            />
            <CPSettingRange
                name={constants.BACKGROUND_CARD_OPACITY}
                value={settings?.[constants.BACKGROUND_CARD_OPACITY]}
                defaultValue={settings?.[constants.BACKGROUND_CARD_OPACITY] ?? 70}
                label="Прозрачность фона у карточки"
                step={5}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.BACKGROUND_CARD_BLUR}
                label="Размытие фона у карточки"
                eventValue={settings?.[constants.BACKGROUND_CARD_BLUR]}
                defaultValue={'10px'}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.SCHEDULE_ELEMENTS_ROUNDING}
                label="Скругление элементов"
                eventValue={settings?.[constants.SCHEDULE_ELEMENTS_ROUNDING]}
                defaultValue={'4px'}
                onChange={onChange}
            />
            <CPSettingSize
                name="photoRoundingSize"
                label="Скругление фотографий"
                eventValue={settings?.photoRoundingSize}
                defaultValue="8px"
                onChange={onChange}
            />
            <CPSettingToggle
                name={commonConstants.SHOW_TITLE}
                isChecked={settings?.[commonConstants.SHOW_TITLE]}
                label="Показывать заголовок"
                onChange={onChange}
            />
            {settings?.[commonConstants.SHOW_TITLE] && (
                <>
                    <CPSettingText
                        eventSetting={settings}
                        title="Заголовок"
                        property={commonConstants.TITLE}
                        hasToggleProperty={false}
                        defaultValue="Программа мероприятия"
                        onUpdate={onChange}
                    />
                    <CPSettingSize
                        name={commonConstants.TITLE_SIZE}
                        label="Размер заголовка"
                        eventValue={settings?.[commonConstants.TITLE_SIZE]}
                        defaultValue={'24px'}
                        onChange={onChange}
                    />
                </>
            )}
            <CPSettingToggle
                name={commonConstants.SHOW_SUBTITLE}
                isChecked={settings?.[commonConstants.SHOW_SUBTITLE]}
                label="Показывать подзаголовок"
                onChange={onChange}
            />
            {settings?.[commonConstants.SHOW_SUBTITLE] && (
                <>
                    <CPSettingText
                        eventSetting={settings}
                        title="Подзаголовок"
                        property={commonConstants.SUBTITLE}
                        hasToggleProperty={false}
                        defaultValue=""
                        onUpdate={onChange}
                    />
                </>
            )}
            <hr />
            <h5>
                <strong>
                    Настройка перерыва
                </strong>
            </h5>
            <CPSettingColor
                name={constants.DELAY_BACKGROUND_COLOR}
                label="Цвет карточки"
                eventColor={settings?.[constants.DELAY_BACKGROUND_COLOR]}
                defaultColor="#FFFFFF"
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.DELAY_TEXT_COLOR}
                label="Цвет текста"
                eventColor={settings?.[constants.DELAY_TEXT_COLOR]}
                defaultColor={commonConstants.DEFAULT_COLOR_MAIN}
                onChange={onChange}
            />
        </>
    );
};

export default CommonStyles;
